import SpinnerCircle from "./SpinnerCircle";

interface Props {
    pxSize: number;
    color: string;
    height?: "full" | "screen" | "mid-screen"
}

const Spinner: React.FC<Props> = ({ pxSize, color, height = "mid-screen" }) => {
    return (
        <div aria-label="loading-spinner"
             className={`flex justify-center items-center gap-4 ${ height === "screen" ? "h-screen" : height === "mid-screen" ? "h-[50vh]" : "h-full"}`}>
            <SpinnerCircle animationDelay="0ms"   color={color} pxSize={pxSize}/>
            <SpinnerCircle animationDelay="200ms" color={color} pxSize={pxSize}/>
            <SpinnerCircle animationDelay="400ms" color={color} pxSize={pxSize}/>
        </div>
    );
}

export default Spinner;
